module.exports = __webpack_public_path__ + "static/media/BandHuntMobile.9306c974.webm";